export default __webpack_public_path__ + "static/media/orange.fab79588.svg";